import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../services/authService';
import styles from '../components/Auth.module.css'; // Importa o mesmo CSS Module
import logo from '../assets/logo.jpg';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    nome: '', sobrenome: '', email: '', password: '',
    telefone: '', cpf: '', data_de_nascimento: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (formData.password.length < 6) {
      setError("A senha deve ter pelo menos 6 caracteres.");
      setLoading(false);
      return;
    }

    try {
      const { email, password, ...profileData } = formData;
      await authService.register(email, password, { data: profileData });

      setSuccess('Cadastro realizado! Verifique seu email para confirmar a conta.');
      setTimeout(() => navigate('/login'), 4000);
    } catch (err) {
      setError(err.message || 'Erro ao cadastrar. Verifique seus dados.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authPageBackground}> {/* Novo container de fundo */}
      <div className={`card ${styles.authCard}`}>
        <div className={styles.authHeader}>
          {/* Placeholder para o logo */}
          <div className={styles.authLogo}>
            <img src={logo} alt="Logo da Empresa" className={styles.authLogo} />
          </div>
          <h2>Crie sua Conta de Barbeiro</h2>
          <p>Comece a gerenciar seus serviços e agenda.</p>
        </div>
        <form onSubmit={handleSubmit} className={styles.authForm}>
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}

          <div className={styles.formGrid}> {/* Novo grid para 2 colunas */}
            <div className="form-group">
              <label htmlFor="nome">Nome</label>
              <input type="text" id="nome" name="nome" className="form-input" value={formData.nome} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="sobrenome">Sobrenome</label>
              <input type="text" id="sobrenome" name="sobrenome" className="form-input" value={formData.sobrenome} onChange={handleChange} required />
            </div>
            <div className={`form-group ${styles.fullWidth}`}> {/* Ocupa 100% da largura */}
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" className="form-input" value={formData.email} onChange={handleChange} required />
            </div>
            <div className={`form-group ${styles.fullWidth}`}>
              <label htmlFor="password">Senha</label>
              <input type="password" id="password" name="password" className="form-input" value={formData.password} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="telefone">Telefone</label>
              <input type="tel" id="telefone" name="telefone" className="form-input" placeholder="(XX) XXXXX-XXXX" value={formData.telefone} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="cpf">CPF</label>
              <input type="text" id="cpf" name="cpf" className="form-input" placeholder="000.000.000-00" value={formData.cpf} onChange={handleChange} />
            </div>
            <div className={`form-group ${styles.fullWidth}`}>
              <label htmlFor="data_nascimento">Data de Nascimento</label>
              <input type="date" id="data_nascimento" name="data_de_nascimento" className="form-input" value={formData.data_de_nascimento} onChange={handleChange} />
            </div>
          </div>
          
          <button type="submit" className={`btn btn-primary ${styles.authButton}`} disabled={loading}>
            {loading ? 'Cadastrando...' : 'Criar Conta'}
          </button>
        </form>
        <div className={styles.authFooter}>
          <p>Já tem uma conta? <Link to="/login">Faça Login</Link></p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;